import { render } from "./OrderTopBar.vue?vue&type=template&id=5ae82f9e&scoped=true"
import script from "./OrderTopBar.vue?vue&type=script&lang=js"
export * from "./OrderTopBar.vue?vue&type=script&lang=js"

import "./OrderTopBar.vue?vue&type=style&index=0&id=5ae82f9e&scoped=true&lang=scss"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae82f9e"]])

export default __exports__